export const STORE_FINDER_FEATURE = 'storeFinder';
